import Swiper from 'swiper/bundle';

export default class Carousel {
  constructor(element) {
    this.element = element;
    this.options = {
      slidesPerView: 3,
      spaceBetween: 40,
      direction: 'horizontal',
      observer: true, // recalcule Swiper si le DOM/CSS du slider change
      observeParents: true, // recalcule aussi si un parent (ex: .news-carousel) change de taille
      pagination: {
        el: this.element.parentElement.querySelector('.swiper-pagination'),
      },
      navigation: {
        nextEl: this.element.parentElement.querySelector('.swiper-button-next'),
        prevEl: this.element.parentElement.querySelector('.swiper-button-prev'),
      },
    };

    this.init();
  }

  init() {
    this.setOptions();

    new Swiper(this.element, this.options);
  }

  setOptions() {
    if ('split' in this.element.dataset) {
      this.options.breakpoints = {
        10: {
          slidesPerView: 1,
        },
        300: {
          slidesPerView: 1,
        },
        800: {
          slidesPerView: 2,
        },
        1400: {
          slidesPerView: 3,
        },
      };
    }

    if ('single' in this.element.dataset) {
      this.options.slidesPerView = 1;
    }

    if ('autoplay' in this.element.dataset) {
      this.options.autoplay = {
        delay: 5000,
        pauseOnMouseEnter: true,
        disableOnInteraction: false,
      };
    }

    if ('loop' in this.element.dataset) {
      this.options.loop = true;
    }

    if ('slides' in this.element.dataset) {
      this.options.slidesPerView =
        this.element.dataset.slides || this.options.slidesPerView;
    }

    if ('direction' in this.element.dataset) {
      this.options.direction = this.element.dataset.direction;
    }

    if ('space' in this.element.dataset) {
      this.options.spaceBetween = this.element.dataset.space;
    }
  }
}
